import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DisplayRequestUnavailableModal } from 'src/app/components/performaction/modals/display-request-unavailable.modal/display-request-unavailable.modal';

@Component({
    templateUrl: './invite-not-found.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InviteNotFoundPage {

  constructor(private modalService: NgbModal) {
    //Constructor cannot be empty.
  }

  ngOnInit() {
    this.RequestUnavailableDialog();
  }

  RequestUnavailableDialog() {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static',
      fullscreen: true,
      windowClass: 'overlay-fullscreen'
    };
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(DisplayRequestUnavailableModal, ngbModalOptions);
  }
}
